import { apiGet, apiPut } from '../../api/client';
import i18next from '../../i18n/initI18n';
import type { MailingCampaign } from './mailingTypes';

/** Старый ключ localStorage — один раз поднимаем данные на сервер при пустом ответе API. */
const LEGACY_LOCAL_KEY = 'mailing_constructor_campaigns_v1';

function isMailingCampaignList(raw: unknown): raw is MailingCampaign[] {
  return Array.isArray(raw);
}

async function migrateLegacyFromBrowserIfNeeded(): Promise<MailingCampaign[]> {
  try {
    const raw = localStorage.getItem(LEGACY_LOCAL_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!isMailingCampaignList(parsed) || parsed.length === 0) return [];
    await apiPut<MailingCampaign[]>('/api/visual-mailings', parsed);
    localStorage.removeItem(LEGACY_LOCAL_KEY);
    return parsed;
  } catch {
    return [];
  }
}

function normalizedName(name: unknown): string {
  return String(name || '').trim().toLowerCase();
}

function assertUniqueVisualMailingNames(list: MailingCampaign[]): void {
  const seen = new Set<string>();
  for (const item of list) {
    const key = normalizedName(item.name);
    if (!key) continue;
    if (seen.has(key)) {
      throw new Error(i18next.t('campaignsPage.chainNameDuplicate'));
    }
    seen.add(key);
  }
}

export async function fetchVisualMailings(): Promise<MailingCampaign[]> {
  const fromServer = await apiGet<MailingCampaign[]>('/api/visual-mailings');
  if (!isMailingCampaignList(fromServer)) return [];
  if (fromServer.length > 0) return fromServer;
  return migrateLegacyFromBrowserIfNeeded();
}

export async function replaceVisualMailings(list: MailingCampaign[]): Promise<void> {
  assertUniqueVisualMailingNames(list);
  await apiPut<MailingCampaign[]>('/api/visual-mailings', list);
}

export async function upsertVisualMailing(campaign: MailingCampaign): Promise<void> {
  const list = await fetchVisualMailings();
  const i = list.findIndex((x) => x.id === campaign.id);
  const next =
    i >= 0 ? list.map((x) => (x.id === campaign.id ? campaign : x)) : [...list, campaign];
  await replaceVisualMailings(next);
}
